'use client';

import {
	BreadcrumbCurrentLink,
	BreadcrumbLink,
	BreadcrumbRoot,
	type BreadcrumbRootProps,
} from '@packages/chakra-v3';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

type BreadcrumbItemProps = BreadcrumbRootProps;

const Breadcrumb = (props: BreadcrumbItemProps) => {
	const path = usePathname();
	const pathSegments = path.split('/').filter(Boolean);

	if (!pathSegments.length) return null;

	const renderBreadcrumbItem = (segment: string, index: number) => {
		const href = `/${pathSegments.slice(0, index + 1).join('/')}`;
		const isLast = index === pathSegments.length - 1;
		const formattedText = segment.replace(/-/g, ' ').replace('faq', 'FAQ');

		return isLast
			? <BreadcrumbCurrentLink key={href} textTransform={'capitalize'}>{formattedText}</BreadcrumbCurrentLink>
			: (
				<BreadcrumbLink key={href} href={href} textTransform={'capitalize'}>
					{formattedText}
				</BreadcrumbLink>
			);
	};

	return (
		<BreadcrumbRoot separator={'/'} {...props}>
			<BreadcrumbLink as={Link} href={'/'}>Home</BreadcrumbLink>
			{pathSegments.map((segment, index) => renderBreadcrumbItem(segment, index))}
		</BreadcrumbRoot>
	);
};

export default Breadcrumb;